<template>
  <div id="app">
    <router-view />
    <v-footer />
  </div>
</template>
<script>
import VFooter from "./components/Footer.vue";
export default {
  name: "Home1",
  components: {
    VFooter
  },
}
</script>
<style lang="less">
.body{
  width: 1920px;
  min-width: 640px;
}
</style>
